export default __webpack_public_path__ + "static/binary-bf38e8811738149a88ac4401135e45c7.png";